/**
 * Reserva DatePicker
 *
 * Generalisierte Version des IBE1 Datepickers zur Verwendung in beliebigen Webseiten.
 */

var _ = require('underscore');
var moment = require('moment');
var Backbone = require('backbone');

var DateTime = require('DateTime');
var TemplateCache = require('TemplateCache');

var DatepickerControlsView = require('./views/DatepickerControlsView');
var Translator = require('translate').singleton;

var Tooltip = require('../Tooltip');
var Registry = require('registry');


var ReservaDatePicker = function(options) {
	_.extend(this, Backbone.Events);
	_.extendOwn(this, {
		/* Required fields */
		form: null, /* Form to use */
		container: null, /* Where to put the datepicker */

		/* Dates */
		from: null,
		to: null,

		/* Date state */
		previousFrom: null,
		previousTo: null,

		/* Calendar configuration */
		from_field: 'from',
		to_field: 'to',
		item: null,
		numberOfMonths: $(window).width() > 600 ? 2 : 1,
		canGoBackInTime: false,

		/* Default date for calendar */
		defaultstartin: null,
		defaultdays: null,

		/* Mobile fixes */
		isTouchDevice: false,

		/* DOM nodes/Views */
		datepicker: null,
		controls: null,
		infotext: null,

		/* Remote models */
		app: null,
		model: null,
		daysmodel: null,
	}, options);

	_.bindAll(this,
		"onSelect", "cellHoverHandler",
		"setFrom", "setTo",
		"disableTooltip",
		"boxCheck",
		"runAwayScreaming"
	);

	/* Validation of parameters */
	if ( !this.form || !this.form.length ) throw new Error("[ReservaDatePicker] Missing form");
	if ( !this.container || !this.container.length ) throw new Error("[ReservaDatePicker] Missing container");

	/* DOM-Elemente sammeln */
	this.from_input = this.form.find('input[name=' + this.from_field + ']');
	this.to_input = this.form.find('input[name=' + this.to_field + ']');

	if ( !this.from_input.length ) {
		this.from_input = $('<input>').attr({
			name: 'from',
			type: 'hidden',
		}).appendTo(this.form);
	}
	if ( !this.to_input.length ) {
		this.to_input = $('<input>').attr({
			name: 'to',
			type: 'hidden',
		}).appendTo(this.form);
	}

	/* Tooltip erzeugen */
	this.tooltip = new Tooltip({
		box: this.container,
		className: "reserva-datepicker-tooltip",
	})

	/* Container vorbereiten (drei Elemente: Controls, Datepicker, Infotext) */
	this.container.html("");
	this.controls = new DatepickerControlsView({
		el: $('<div/>').addClass('reserva-datepicker-controls').appendTo(this.container)[0],
		model: this.model,
		datepicker: this,
	});
	this.datepicker = $('<div/>').addClass('reserva-datepicker-container').appendTo(this.container);
	this.infotext = $('<div/>').appendTo(this.container);

	this.diffBeginDate = parseDate("2014-10-01");	

	/* State Variables */
	this.isOpen = false;
	this.initialized = false;

	this.pointerX = -1000;
	this.pointerY = -1000;

	this.select_step = 0;
	this.currentlySelectedDaysCount = 0;
	this.last_to = null;

	this.last_tooltip = "";
	this.tooltipInitialText = "und jetzt das Abreisedatum...";
	this.update_days_count_timer = null; // int: Interval ID
	this.datepicker_box_bounds = null;
	this.unavailable_shown = false;

	this.invalid_nightscount = false; /* Amount of nights is too low/high */
	this.usedDefaultDate = false;
	
	if ( !this.model ) {
		this.model = new Backbone.Model();
		this.model.set(this.from_field, null);
		this.model.set(this.to_field, null);
	}

	/* Bei Änderungen an Model aktualisieren auch wir unsere Daten */
	this.modelChanging = false;

	this.model.on('change:' + this.from_field, function(e) {
		if ( this.modelChanging ) return;
		this.setFrom(e.attributes[this.from_field]);
	}.bind(this));

	this.model.on('change:' + this.to_field, function(e) {
		if ( this.modelChanging ) return;
		this.setTo(e.attributes[this.to_field]);
	}.bind(this));

	this.model.on('change:select_mode', function(e) {
		this.datepicker.datepicker("refresh");
	}.bind(this));

	this.daysmodel.on('change', function(e) {
		if ( !e.attributes.days ) return;
		//this.canGoBackInTime = e.attributes.days.length === 0;
		//console.log("[ReservaDatePicker] canGoBackInTime = ", this.canGoBackInTime);

		this.infotext.html(TemplateCache.render("datepicker-item-info", {
			item: this.daysmodel.toJSON(),
		}));
	}.bind(this));
};



/**
 * Datepicker initialisieren
 */
ReservaDatePicker.prototype.init = function() {
	var self = this;
	var from, to;

	/* Datum aus dem Model laden */
	var temp;
	if ( temp = this.model.get(this.from_field) ) {
		console.log("DT: Form: this.from => ", temp);
		from = parseDate(temp);
	}
	if ( temp = this.model.get(this.to_field) ) {
		console.log("DT: Form: this.to => ", temp);
		to = parseDate(temp);
	}

	/* There are horrible typed languages. And there is JavaScript */
	var isBroken = function(something) {
		if ( typeof something === "string" ) {
			if ( something.indexOf('NaN') !== -1 ) {
				return true;
			}
		}
		if ( something.toString() === "Invalid Date" ) {
			return true;
		}

		return false;
	};

	// If any of the dates are in the past, ignore both
	var today = DateTime.resetTimeFields(new Date());
	if ( +from < +today || +to < +today ) {
		console.log("DT: Resetting values because they're in the past");
		from = null;
		to = null;
	}

	/* If we didn't get a saved or otherwise valid result, just use the defaults */
	if ( !from || !to || isBroken(from) || isBroken(to) ) {
		console.log("DatePicker: Using default date + time");
		var defaultstartin = this.defaultstartin || 0;
		var defaultdays = this.defaultdays || 1;
		from = addDays(new Date(), parseInt(defaultstartin, 10));
		to = addDays(from, parseInt(defaultdays, 10));

		this.usedDefaultDate = true;
	}

	this.controls.render();

	/* Datepicker konfigurieren */
	if ( !this.datepicker.datepicker ) {
		/* jQuery UI is not initialized properly :-( */
		var e = new Error("[ReservaDatePicker] jQuery UI Datepicker unavailable", this.datepicker.datepicker);
		if ( window.Raven && Raven.isSetup() ) {
			Raven.captureException(e);
		}
		throw e;
	}

	this.datepicker = this.datepicker.datepicker({
		dateFormat: 'yy-mm-dd',
		/* @todo Translation */
		altFormat: 'dd.mm.yy',
		dayNames: Translator.get("dayNames"),
		dayNamesMin: Translator.get("dayNamesMin"),
		dayNamesShort: Translator.get("dayNamesShort"),
		monthNames: Translator.get("monthNames"),
		monthNamesShort: Translator.get("monthNamesShort"),
		nextText: "&rarr;",
		prevText: "&larr;",
		weekHeader: "",
		showWeek: true,
		firstDay: 1,
		numberOfMonths: this.numberOfMonths,
		onSelect: this.onSelect,
		minDate: new Date(),

		beforeShowDay: function (dd) {
			var c = [];
			var today = DateTime.resetTimeFields(new Date());
			var d = new Date(dd);
			var humandate = makeDate(dd);
			var selectable = true;

			var days = this.daysmodel ? this.daysmodel.get("days") : [];
			if ( days.length > 0 ) {
				// Only show valid dates
				var seen = false;
				for (var i = 0, date; date = days[i]; ++i) {
					if ( date.date != humandate ) continue;
					seen = true;
					break;
				}
				if ( seen ) {
					c.push("available");
				} else {
					c.push("unavailable");
				}
			}

			if ( +today > +d || !selectable ) {
				c.push("day_past");
			}

			/* This is only needed for the first render,
			   after that the hover handler will take care of that */
			if ( this.from && this.to && this.model.get("select_mode") !== "none" ) {
				if ( +d === +this.from ) c.push("selection-start");
				if ( +d === +this.to   ) c.push("selection-end");

				if ( +d >= +this.from && +d <= +this.to ) {
					c.push("selected");
				}
				if ( +d <= +this.from && +d >= +this.to && +d >= +today ) {
					c.push("selected");
				}
			}

			if ( d ) {
				c.push("day_" + diffDate( this.diffBeginDate, d ))
			};
			return [ selectable, c.join(" "), "" ];
		}.bind(this),

	});

	// Am Ende das ermittelte Datum überall übernehmen
	this.setFrom(DateTime.resetTimeFields(from));
	this.setTo(DateTime.resetTimeFields(to));

	logVars("InitialDate", {from: this.from, to: this.to});

	this.datepicker.datepicker("setDate", null ); // unset default date
	this.datepicker.find('.ui-datepicker-current-day').removeClass('ui-datepicker-current-day');
	this.datepicker.find('.ui-state-active').removeClass('ui-state-active');

	this.datepicker.on("mouseenter", "td", function(e) {
		if ( e.isTrigger ) {
			/* Sometimes the jQuery UI DatePicker sends fake events. Ignore them. */
			return;
		}
		self.cellHoverHandler(e, this);
	});

	// Maus-Position fürs Tooltip tracken
	$(document).mousemove(function(e) {
		this.pointerX = e.pageX;
		this.pointerY = e.pageY;
	}.bind(this));

	/* Infotext einmal rendern */
	this.infotext.html(TemplateCache.render("datepicker-item-info", {
		item: this.daysmodel.toJSON(),
	}));

	if ( this.app ) this.app.trigger("DatePicker.Initialized");
	this.initialized = true;

};

/**
 * Click-Handler für Daten
 */
ReservaDatePicker.prototype.onSelect = function(dateText, inst) {
	console.log("[DatePicker.onSelect] called:", dateText);
	logVars("[DatePicker.onSelect] state:", {from: this.from, to: this.to, currentlySelectedDaysCount: this.currentlySelectedDaysCount});

	/* Prevent selection if day is unavailable. And show a tooltip. */
	var dayslist = this.daysmodel.get("days");
	if ( dayslist.length > 0 ) {
		var select_from_obj = _.find(dayslist, function(item) {
			return item.date == dateText;
		});
		if ( !select_from_obj && this.currentlySelectedDaysCount === 0 ) {
			let tooltip = Translator.get("no_arrival");
			this.setTooltip(tooltip);
			setTimeout(function() {
				this.disableTooltip();
			}.bind(this), 2000);
			/* @todo Make this more clever */
			return false;
		}
	}

	this.disableTooltip();

	/* Falls der User einen Tag gegen Ende des letzten wählbaren Monats ausgewählt hat,
       den Kalender eins weiter springen lassen um eine Auswahl für den nächsten Monat zu ermöglichen.
	*/

	// parseInt(parts[1], 10) === this.datepicker.datepicker("getDate").getMonth() + 1 && 
	/*
	let parts = dateText.split('-');
	if ( parts[2] > 14 ) {
		setTimeout(() => this.datepicker.find('.ui-datepicker-next').click(), 1000);
	}
	*/

	var from, to;

	if ( this.currentlySelectedDaysCount == 0 ) {
		/* Schritt 1: Start-Datum auswählen */

		this.previousFrom = this.from;
		this.previousTo = this.to;

		from = parseDate(dateText);
		this.setTo(null);
		this.currentlySelectedDaysCount = diffDate( this.diffBeginDate, parseDate(dateText) );
		this.selectedDaysCount = diffDate( this.diffBeginDate, parseDate(dateText) );

		this.setTooltip(this.tooltipInitialText);
		if ( this.app && !this.app.get("isTouchDevice") ) {
			var startX = this.pointerX;
			var startY = this.pointerY;
		}

		if ( this.model.get("select_mode") === "none" ) {
			this.model.set("select_mode", "exact");
		}

		this.container.addClass('selecting');
	} else {
		/* Schritt 2: End-Datum auswählen */
		from = this.from;
		to = parseDate(dateText);

		/* Swap reverse selection */
		if ( +from > +to ) {
			console.log("[DatePicker] Swapping from and to");
			to = this.from;
			from = parseDate(dateText);
		}
		this.currentlySelectedDaysCount = 0;
		this.container.removeClass('selecting');
	}


	if ( from ) DateTime.resetTimeFields(from);
	if ( to ) DateTime.resetTimeFields(to);

	if ( +from === +to ) {
		// Start + End on the same day. Doesn't work for us.
		console.log("[DatePicker.onSelect] Ignored same-day selection");
		this.runAwayScreaming();
		return;
	}

	if ( from ) {
		this.setFrom(from);
	}

	if ( to ) {
		this.setTo(to);
	}

	this.datepicker.datepicker("refresh");
	if ( this.from && this.to ) {	
		if ( this.app ) {
			this.app.trigger("DatePicker.dateSelected", this);
		}
	}

	logVars("[DatePicker.onSelect] state2:", {from: this.from, to: this.to, currentlySelectedDaysCount: this.currentlySelectedDaysCount});
};


ReservaDatePicker.prototype.setFrom = function(from) {
	if ( typeof from === "string" ) {
		/* We expecent internally a Date object, but our model gets only a string for form processing */
		from = parseDate(from);
	}

	if ( this.from === from ) return;
	this.from = from;

	var from_date = ( from === null ) ? "" : makeDate(this.from);
	console.log("[Datepicker] setFrom:", from, from_date);
	this.from_input.val(from_date);

	var new_values = {};
	new_values[this.from_field] = from ? from_date : null;
	if ( this.to && this.model.get("select_mode") !== "flex" ) {
		new_values["nights"] = DateTime.moment(this.to).diff(DateTime.moment(this.from), 'days');
	}
	this.modelChanging = true;
	this.model.set(new_values);
	this.modelChanging = false;
};

ReservaDatePicker.prototype.setTo = function(to, find_a_name_for_me) {
	if ( typeof to === "string" ) {
		/* We expecent internally a Date object, but our model gets only a string for form processing */
		to = parseDate(to);
	}

	if ( this.to === to ) return;
	this.to = to;

	var to_date = ( to === null ) ? "" : makeDate(this.to);
	console.log("[Datepicker] setTo:", to, to_date);
	this.to_input.val(to_date);

	var new_values = {};
	new_values[this.to_field] = to ? to_date : null;

	if ( this.model.get("select_mode") !== "flex" ) {
		new_values["nights"] = Math.abs(DateTime.moment(this.to).diff(DateTime.moment(this.from), 'days'));
	}

	this.modelChanging = true;
	this.model.set(new_values);
	this.modelChanging = false;

	if ( this.to && !find_a_name_for_me ) {
		this.datepicker.datepicker("setDate", this.from);
	}
};


ReservaDatePicker.prototype.setTooltip = function(text) {
	if ( this.isTouchDevice ) return;
	this.last_tooltip = text;
	this.tooltip.set(text);
};


ReservaDatePicker.prototype.disableTooltip = function() {
	if ( this.update_days_count_timer ) {
		window.clearInterval(this.update_days_count_timer);
		this.update_days_count_timer = null;
	}
	this.last_tooltip = null;
	this.tooltip.hide();
};

/**
 * Callback for mouseenter
 *
 * Because "this" is a special snowflake in JS, we do this dance to get the 'td' without using a self variable.
 */
ReservaDatePicker.prototype.cellHoverHandler = function(e, node) {
	if ( this.app && this.app.get('isTouchDevice') ) return;
	var day = getDayClass(node);
	var dayslist = this.daysmodel ? this.daysmodel.get("days") : [];
	var product_name = this.daysmodel ? this.daysmodel.get("name") : "";
	var min_nights = null;
	var max_nights = null;
	var valid_nights = [];
	var nights;
	var tooltip = null;

	/* Produktname in eigene Zeile, falls definiert */
	if ( product_name ) product_name += "<br>";

	if ( $(e.currentTarget).hasClass('hasDatePicker') ) return;
	if ( !this.currentlySelectedDaysCount || !this.from ) return;

	var from_m = moment(this.from);
	var new_to = addDays(this.from, day - this.currentlySelectedDaysCount);

	if ( +new_to === +this.from  ) {
		nights = 1;
	} else if ( +new_to > +this.from  ) {
		nights = diffDate(this.from, new_to);
	} else {
		if ( this.canGoBackInTime ) {
			nights = diffDate(new_to, this.from);
		} else {
			console.log("Returing cellHoverHandler", new_to, this.from);
			return;
		}
	}

	this.setTo(new_to, true);


	var select_from_date = makeDate(this.from);
	if ( dayslist.length > 0 ) {
		var select_from_date = _.find(dayslist, function(item) {
			return item.date == select_from_date;
		});
		if ( select_from_date ) {
			if ( typeof select_from_date.nights !== "undefined" ) {
				valid_nights = select_from_date.nights;
			} else {
				min_nights = select_from_date.min;
				max_nights = select_from_date.max;
			}
		} else {
			tooltip = Translator.get("no_arrival");
			return;
		}
	}

	// Limit date ranges
	if ( valid_nights.length > 0 && nights > 0 && _.indexOf(valid_nights, nights) === -1 ) {
		this.invalid_nightscount = true;
	} else {
		this.invalid_nightscount = false;
	}

	let max_nightscount = this.model.get("select_mode") === "flex" ? 100 : 21;

	if ( nights > max_nightscount ) {
		this.invalid_nightscount = true;
	}

	if ( nights > 0 ) {
		var nightstext = nights + " " + ( nights > 1 ? Translator.get("nights") : Translator.get("night") );
		if ( this.invalid_nightscount ) {
			if ( nights > max_nightscount ) {
				//tooltip = `Eine Online-Buchung ist für maximal ${max_nightscount} Nächte möglich.`;
				tooltip = "DISABLE";
			} else {
				
				var valid_text;
				if ( valid_nights.length > 1 ) {
					var valid_nights_copy = valid_nights.slice();
					var last_night = valid_nights_copy.pop();
					valid_text = valid_nights_copy.join(" ,") + " " + Translator.get("or") + " " + last_night;
				} else {
					valid_text = valid_nights[0].toString();
				}

				tooltip = (
				  product_name + Translator.get("available") + " " + valid_text  + " " + Translator.get("overnight")
				  + "<br>" + Translator.get("upon_arrival") + " " + from_m.format("LL")
				);
			}
		} else {
			tooltip = nightstext;
		}

		/* Mindestaufenthalt an diesem Tag */
		if ( !this.invalid_nightscount && min_nights !== null && nights < min_nights ) {
			tooltip = (product_name + Translator.get("min_stay") + " " + min_nights + " " + Translator.get("nights")
						  + "<br>" + Translator.get("upon_arrival") + " " + from_m.format('LL') );
			this.invalid_nightscount = true;
		}

		/* Maximale Anzahl Nächste */
		if ( !this.invalid_nightscount && max_nights !== null && nights > max_nights ) {
			tooltip = (product_name + Translator.get("max") + " " + max_nights + " " + Translator.get("nights_available")
						  + "<br>" + Translator.get("upon_arrival") + " " + from_m.format('LL') );
			this.invalid_nightscount = true;
		}

	} else {
		// Tooltip deaktivieren, außer es ist der initiale Text (Hack)
		if ( this.last_tooltip !== this.tooltipInitialText ) {
			if ( this.canGoBackInTime ) {
				tooltip = "DISABLE";
			} else {
				tooltip = Translator.get("departure_date");
			}
		}
	}

	if ( this.last_to != makeDate( this.to ) ) {
		// Refresh classes
		var start_index = diffDate(this.diffBeginDate, this.from);
		var end_index = diffDate(this.diffBeginDate, this.to);

		var cellclass = this.invalid_nightscount ? "invalid_nightscount" : "selected";

		this.datepicker.find('.invalid_nightscount').removeClass("invalid_nightscount");
		this.datepicker.find('.selected').removeClass("selected");

		/* Start/End classes */
		if ( start_index !== end_index ) {
			this.datepicker.find('.day_' + start_index).addClass("selection-start");
			this.datepicker.find('.day_' + end_index).addClass("selection-end");
		}

		/* Anything before the start */
		for(var i = 2; i <= start_index; ++i) {
			this.datepicker.find('.day_' + i).addClass('unavailable');
		}

		/* Selected classes */
		if ( end_index === start_index ) {
			this.datepicker.find('.day_' + start_index).addClass(cellclass);
		} else if ( end_index > start_index ) {
			for(var i = start_index; i <= end_index; ++i) {
				this.datepicker.find('.day_' + i).addClass(cellclass);
			}
		} else {
			if ( this.canGoBackInTime ) {
				for(var i = start_index; i > end_index - 1; --i) {
					this.datepicker.find('.day_' + i).addClass(cellclass);
				}
			}
		}

		this.last_to = makeDate( this.to );
	}

	if ( tooltip ) {
		if ( tooltip === "DISABLE" ) {
			this.disableTooltip();	
		} else {
			this.setTooltip(tooltip);
		}
	}
};


ReservaDatePicker.prototype.boxCheck = function() {

	// Calculate the datepicker box to prevent strange tooltip positions
	if ( ! this.container_box_bounds ) {
		var container = this.container;
		console.log("container", container);
		var offset = container.offset();
		this.container_box_bounds = {
			x1: offset.left,
			y1: offset.top,
			x2: offset.left + container.outerWidth(),
			y2: offset.top + container.outerHeight(),
		};
	}

	/* Check if the mouse pointer is inside the datepicker box

	  x1,y1
		+--------+
		| Px,Py  |
		|   +    |
		+--------+
				x2,y2
	*/
	var box = this.container_box_bounds;
	this.inside_container = (
			this.pointerX >= box.x1
		 && this.pointerY >= box.y1
		 && this.pointerX <= box.x2
		 && this.pointerY <= box.y2
	);

	if ( !this.inside_container && this.currentlySelectedDaysCount ) {
		if ( !this.firstSeenOutside ) {
			this.firstSeenOutside = (new Date()).getTime();
		}
		var now = (new Date()).getTime();
		if ( now - this.firstSeenOutside > 1500 ) {
			// User has left the DatePicker for 1.5 seconds, request it's close through the app
			console.log("[ReservaDatePicker] Lost user focus while selecting");
			this.runAwayScreaming();
			this.firstSeenOutside = null;
		}
	} else {
		this.firstSeenOutside = null;
	}
};

ReservaDatePicker.prototype.runAwayScreaming = function() {
	if ( this.isTouchDevice ) {
		return;
	}

	this.disableTooltip();
	this.currentlySelectedDaysCount = 0;
	this.setFrom(this.previousFrom);
	this.setTo(this.previousTo);

	if ( this.previousFrom ) {
		this.datepicker.datepicker("setDate", null);
	}

	this.datepicker.datepicker("refresh");
	this.container.removeClass('selecting');
};

/**
 * Aufrufen, wenn der DatePicker geöffnet wurde. Registriert Timer.
 */
ReservaDatePicker.prototype.opened = function() {
	this.boxCheckInterval = window.setInterval(this.boxCheck, 100);
	this.isOpen = true;
};

/**
 * Aufrufen, wenn der DatePicker wieder geschlossen wurde.
 * Deaktiviert alle Timer und deaktiviert den Tooltip.
 */
ReservaDatePicker.prototype.closed = function() {
	if ( !this.isOpen ) return;
	this.isOpen = false;

	window.clearInterval(this.boxCheckInterval);
	this.boxCheckInterval = null;

	this.disableTooltip();
	this.container.removeClass('selecting');
};

/**
 * Wird aufgerufen, wenn die Controls Fokus bekommen.
 * Falls wir gerade in einer Auswahl sind, wird diese beendet.
 */
ReservaDatePicker.prototype.handleControlInputFocus = function() {
	if ( this.isTouchDevice ) {
		return;
	}

	if ( this.currentlySelectedDaysCount !== 0 ) {

		this.disableTooltip();
		this.currentlySelectedDaysCount = 0;

		this.container.removeClass('selecting');
	}

};

/* Example:
var DatePicker = new ReservaDatePicker();
DatePicker.init();

*/

/**
 * Helper functions
 */

function getDayClass (o) {
	return $.grep(o.className.split(" "), function( v, i ) { return v.indexOf('day_') === 0 } ).join().replace("day_", "");
}


/* @todo Replace with DateTime.parse */
function parseDate (d) {
	var parts = d.split("-");
	return new Date(parts[0], parts[1] - 1, parts[2]);
}

/* @todo Replace with moment(to).diff(from, 'days') */
function diffDate (from, to) {
	return Math.round( ( to - from) / ( 1000*60*60*24 ) );
}

/* @todo Replace with moment(date).add(days, 'days') */
function addDays (date, days) {
	var result = new Date(date);
	result.setDate(date.getDate() + days);
	return result;
}

/* @todo Replace with moment(d).format('YYYY-MM-DD') */
function makeDate (d) {
	if (!d) { return };
	return (
		  d.getFullYear()
		+ "-"
		+ ( "0" + (d.getMonth() + 1) ).slice(-2)
		+ "-"
		+ ( "0" + d.getDate()).slice(-2)
	);
}

/**
 * Debug helper: Print a prefix + a bunch of variables
 */
var logVars = function(prefix, variables) {
	console.log(prefix, _.map(variables, function(value, key) {
		return key + ":(" + value + ")";
	}).join(" "));
};

module.exports = ReservaDatePicker;



// WEBPACK FOOTER //
// /Users/bm/app/code/jsapps/modules/reserva/engine/ReservaDatePicker.js